/**
 * ConsumerTransactionTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";
import {ConsumerTransaction} from "./ConsumerTransaction";
import {ConsumerTransactionCollection} from "./ConsumerTransactionCollection";

export class ConsumerTransactionTag extends TagAbstract {
    /**
     * Returns a specific transaction for the authenticated user
     *
     * @returns {Promise<ConsumerTransaction>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async get(transactionId: string): Promise<ConsumerTransaction> {
        const url = this.parser.url('/consumer/transaction/$transaction_id<[0-9]+|^~>', {
            'transaction_id': transactionId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerTransaction;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a paginated list of transactions which are assigned to the authenticated user
     *
     * @returns {Promise<ConsumerTransactionCollection>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getAll(startIndex?: number, count?: number, search?: string): Promise<ConsumerTransactionCollection> {
        const url = this.parser.url('/consumer/transaction', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
                'startIndex': startIndex,
                'count': count,
                'search': search,
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerTransactionCollection;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
